import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function resetProcess(token, params) {

    return Api.post(REQUEST_URLS.FIN_CHECK.RESET_PROCESS, params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default resetProcess;